import { render, staticRenderFns } from "./EmrTreatmentOPD.vue?vue&type=template&id=504ae213&"
import script from "./EmrTreatmentOPD.vue?vue&type=script&lang=js&"
export * from "./EmrTreatmentOPD.vue?vue&type=script&lang=js&"
import style0 from "./EmrTreatmentOPD.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports